<template>
  <form @submit.prevent="addDevice">
    <HorizontalStepBullets
      :currentStep="this.currentStep"
      class="steps-bullets"
      :totalSteps="this.totalSteps"
      :stepTitles="['General', 'Details', 'Inspection']"
    />
    <div class="multiple-div" name="step1" v-if="this.currentStep == 1">
      <InputDash
        label="REF"
        name="REF"
        :isTextArea="false"
        placeholder="Device REF"
        :isDisabled="false"
        v-model="ref"
        :validation="!this.inValidFields.includes('ref')"
      />
      <InputSelect
        label="Device Type"
        name="type"
        :options="[
          { name: 'Single' },
          { name: 'Subpart' },
          { name: 'Assembly' },
        ]"
        :value="devType"
        v-model="devType"
      />
      <InputAutocomplete
        label="Production Flow"
        name="ProductionFlow"
        searchUrl="management/productionFlow/"
        :isTextArea="false"
        placeholder="Production Flow"
        :isDisabled="false"
        :value="flow.name"
        :key="1"
        @selectedItem="gotSelectedFlow"
        :validation="!this.inValidFields.includes('flow')"
      />
      <InputDash
        label="Description"
        name="description"
        :isTextArea="true"
        placeholder="Description"
        :isDisabled="false"
        v-model="description"
        :validation="!this.inValidFields.includes('description')"
      />
    </div>

    <div class="multiple-div" name="step2" v-if="this.currentStep == 2">
      <h4>TYPE SPECIFIC INFO</h4>
      <InputAutocomplete
        v-if="devType != 'Assembly'"
        label="Raw Material"
        name="RawMaterials"
        :key="2"
        searchUrl="management/rawmaterials/"
        :isTextArea="false"
        placeholder="Raw Material"
        :isDisabled="false"
        :value="rawMat.name"
        @selectedItem="gotSelectedRawMat"
        :validation="!this.inValidFields.includes('rawMaterial')"
      />
      <DynamicPartsList
        v-if="devType == 'Assembly'"
        label="Subparts"
        name="Subparts"
        :currentParts="parts"
        @updateParts="gotParts"
      />
    </div>

    <div class="multiple-div" name="step3" v-if="this.currentStep == 3">
      <label>Technical Drawing</label>
      <ImageInput v-model="deviceDrawing">
        <div slot="activator">
          <div v-if="!deviceDrawing" class="image-selector">
            <img src="@/assets/images/drawing-select@2x.png" alt="avatar" />
          </div>
          <div v-else class="image-selector selected">
            <img :src="deviceDrawing.base64" alt="device image" />
          </div>
        </div>
      </ImageInput>
      <ImageDrawCanvas
        @closeDrawing="stopImageDrawing"
        :currentImage="deviceDrawing"
        v-if="isDrawingViewOpen"
        @drawingComplete="saveArrows"
      />
      <label class="margin-top">Inspection Requirements</label>
      <StaticCustomValueList
        v-if="receivedArrows > 0"
        label="Inspection Requirements"
        name="InspectionRequirements"
        :neededValues="receivedArrows"
        :values="inspectionRequirements"
        @updateValues="gotRequirements"
      />
      <span class="no-requirements" v-else
        >No Requirements selected/needed</span
      >
      <div>
        <label for="deviations">IPC</label>
        <InputToggle
          @toggle="toggleDev"
          :isChecked="this.IPC"
          :isDisabled="false"
        />
      </div>
      <label class="margin-top">Defaults - Final inspection</label>
      <select
        name="final-defaults"
        multiple
        v-model="finDefaults"
        class="multiple-select"
      >
        <option value="complete">Complete</option>
        <option value="burs">Burs</option>
        <option value="visual">Visual</option>
        <option value="functionality">Functionality</option>
      </select>
    </div>

    <div class="buttons">
      <BaseButton
        type="button"
        v-if="this.currentStep == 1"
        :key="1"
        color="tertiary"
        size="modal-sm"
        @click.native="emitClose(true)"
        >Cancel</BaseButton
      >
      <BaseButton
        type="button"
        v-if="this.currentStep != 1"
        :key="2"
        color="tertiary"
        size="modal-sm"
        @click.native="prevStepForm"
        >Previous</BaseButton
      >
      <BaseButton
        type="submit"
        v-if="this.currentStep == this.totalSteps"
        :key="3"
        color="primary"
        size="modal-sm"
        >Add</BaseButton
      >
      <BaseButton
        type="button"
        v-else
        color="primary"
        :key="4"
        size="modal-sm"
        @click.native="nextStepForm"
        >Continue</BaseButton
      >
    </div>
  </form>
</template>

<script>
import BaseButton from "@/components/base/Button";
import InputDash from "@/components/base/InputDash";
// import ImageInput from '@/components/base/ImageInput.vue'
import ImageInput from "@/components/base/ImagePDFInput.vue";
import InputAutocomplete from "@/components/base/InputAutocomplete";
import InputSelect from "@/components/base/InputSelect";
import HorizontalStepBullets from "@/components/base/HorizontalStepBullets";
import DynamicPartsList from "@/components/base/DynamicPartsList";
import ImageDrawCanvas from "@/components/ImageDrawCanvas";
import StaticCustomValueList from "@/components/base/StaticCustomValueList";
import InputToggle from "@/components/base/InputToggle";

export default {
  components: {
    InputDash,
    ImageInput,
    BaseButton,
    InputSelect,
    ImageDrawCanvas,
    InputAutocomplete,
    DynamicPartsList,
    HorizontalStepBullets,
    StaticCustomValueList,
    InputToggle,
  },
  props: {
    title: String,
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 3,
      ref: "",
      IPC: true,
      devType: "Single",
      flow: { id: "", name: "" },
      description: "",
      parts: null,
      image: "",
      rawMat: { id: "", name: "" },
      inValidFields: [],
      inspectionRequirements: [],
      filteredParts: [],
      finDefaults: [],

      isDrawingViewOpen: false,
      finalBase64: "",
      deviceDrawing: null,
      saving: false,
      saved: false,
      receivedArrows: 0,
    };
  },
  methods: {
    addDevice() {
      var url, params;
      var that = this;

      this.inValidFields = [];

      let filteredRequirements = that.inspectionRequirements.filter(function(
        el
      ) {
        return el.letter != "" && el.inspectionName != "";
      });

      // if(filteredRequirements == null || filteredRequirements == "" || filteredRequirements == undefined || filteredRequirements.length != that.inspectionRequirements.length) {
      //   this.inValidFields.push("filteredRequirements")
      // }

      if (this.deviceDrawing == null || this.deviceDrawing.base64 == "") {
        this.inValidFields.push("deviceDrawing");
      }

      var filteredIPCRequirements = [];
      // for (let i = 0; i < filteredRequirements.length; i++) {
      //   filteredIPCRequirements.push({
      //     letter: filteredRequirements[i].letter,
      //     IPCType: filteredRequirements[i].inspectionType,
      //     IPCName: filteredRequirements[i].inspectionName
      //   });
      // }

      for (const req of filteredRequirements) {
        if (req.isIPC) {
          filteredIPCRequirements.push({
            letter: req.letter,
            IPCType: req.inspectionType,
            IPCName: req.inspectionName,
          });
        }
      }
      // filteredIPCRequirements.push({
      //   letter: "bool",
      //   IPCName: "visual",
      //   IPCType: "NOK - OK"
      // });

      var filteredFinalRequirements = [];
      for (let i = 0; i < filteredRequirements.length; i++) {
        if (filteredRequirements[i].isIPC == false) {
          filteredFinalRequirements.push(filteredRequirements[i]);
        }
      }

      var valueCounter = 0;
      for (let d = 0; d < filteredFinalRequirements.length; d++) {
        let el = filteredFinalRequirements[d];
        if (
          el.inspectionName == undefined ||
          (el.letter != "" &&
            el.inspectionName != "" &&
            el.inspectionType != "" &&
            el.value != "")
        ) {
          valueCounter += 1;
        }
      }

      // if(filteredFinalRequirements.length != valueCounter) {
      //   this.inValidFields.push("inspections")
      // }
      for (let d = 0; d < this.finDefaults.length; d++) {
        filteredFinalRequirements.push({
          letter: "bool",
          inspectionName: this.finDefaults[d],
          inspectionType: "NOK - OK",
          isIPC: this.IPC,
        });
        if (this.IPC) {
          filteredIPCRequirements.push({
            letter: "bool",
            IPCName: this.finDefaults[d],
            IPCType: "NOK - OK",
          });
        }
      }

      switch (this.devType) {
        case "Single":
          url = this.$endpoint + "management/devices/part";
          if (this.IPC) {
            params = {
              ref: this.ref,
              rawMaterialID: this.rawMat.id,
              description: this.description,
              flowID: this.flow.id,
              typeBonID: "1",
              image: this.deviceDrawing.base64,
              inspection: filteredFinalRequirements,
              ipc: this.IPC ? "1" : "0",
              IPC: filteredIPCRequirements,
            };
          } else {
            params = {
              ref: this.ref,
              rawMaterialID: this.rawMat.id,
              description: this.description,
              flowID: this.flow.id,
              typeBonID: "1",
              image: this.deviceDrawing.base64,
              inspection: filteredFinalRequirements,
              
            };
          }
          break;
        case "Subpart":
          url = this.$endpoint + "management/devices/part";
          if (this.IPC) {
            params = {
              ref: this.ref,
              rawMaterialID: this.rawMat.id,
              description: this.description,
              flowID: this.flow.id,
              typeBonID: "2",
              image: this.deviceDrawing.base64,
              inspection: filteredFinalRequirements,
            ipc: this.IPC ? "1" : "0",
              IPC: filteredIPCRequirements,
            };
          } else {
            params = {
              ref: this.ref,
              rawMaterialID: this.rawMat.id,
              description: this.description,
              flowID: this.flow.id,
              typeBonID: "2",
              image: this.deviceDrawing.base64,
              inspection: filteredFinalRequirements,
            ipc: this.IPC ? "1" : "0",
              IPC: filteredIPCRequirements,
            };
          }

          break;
        case "Assembly":
          url = this.$endpoint + "management/devices/assembly";
          params = {
            ref: this.ref,
            description: this.description,
            flowID: this.flow.id,
            parts: this.filteredParts,
            image: this.deviceDrawing.base64,
            inspection: filteredFinalRequirements,
            ipc: this.IPC ? "1" : "0",
            IPC: filteredIPCRequirements,
          };
          break;
      }
      if (this.inValidFields.length == 0) {
        this.$http
          .post(url, params)
          .then(function(response) {
            that.$emit("closeModal", true);
            that.$swal(
              `${that.ref} added!`,
              `Your device has been successfully added.`,
              "success"
            );
          })
          .catch(function(error) {
            if (error.response.status === 409) {
              that.$swal(
                "Revise your device?",
                `Please recheck your device info, it seems like this reference already exists.`,
                "warning"
              );
            } else {
              that.$swal(
                "Oops that went wrong?",
                `Please contact the admin with the following info: ${error}`,
                "error"
              );
            }
          });
      }
      // } else {
      //   that.$swal(
      //     "Something isn't right!",
      //     `Some of the values aren't filled in correctly.`,
      //     'error'
      //   );
      // }
    },
    emitClose(isClicked) {
      this.$emit("closeModal", isClicked);
    },
    nextStepForm() {
      this.inValidFields = [];

      if (this.currentStep == 1) {
        if (this.ref == "") {
          this.inValidFields.push("ref");
        }

        if (this.description == "") {
          this.inValidFields.push("description");
        }

        if (this.flow == { id: "", name: "" }) {
          this.inValidFields.push("flow");
        }
      } else if (this.currentStep == 2) {
        if (this.devType == "Assembly") {
          this.filteredParts = this.parts.filter(function(el) {
            return el.name != "" || el.id != "" || el.amount != "";
          });

          if (
            this.filteredParts == null ||
            this.filteredParts == "" ||
            this.filteredParts == undefined
          ) {
            this.inValidFields.push("filteredParts");
          }
        } else {
          if (
            this.rawMat.id == null ||
            this.rawMat.id == "" ||
            this.rawMat.id == undefined
          ) {
            this.inValidFields.push("rawMaterial");
          }
        }
      }

      if (this.inValidFields.length == 0) {
        this.currentStep += 1;
      }
    },
    prevStepForm() {
      this.currentStep -= 1;
    },
    gotParts(newParts) {
      this.parts = newParts;
    },
    gotSelectedFlow(receivedItem) {
      this.flow = receivedItem;
    },
    gotSelectedRawMat(receivedItem) {
      this.rawMat = receivedItem;
    },
    startImageDrawing() {
      this.isDrawingViewOpen = true;
    },
    stopImageDrawing() {
      this.isDrawingViewOpen = false;
    },
    uploadImage() {
      this.saving = true;
      this.isDrawingViewOpen = false;
      setTimeout(() => this.savedAvatar(), 1000);
    },
    savedAvatar() {
      this.saving = false;
      this.saved = true;
    },
    gotValues(newValues) {
      this.values = newValues;
    },
    gotRequirements(newValues) {
      this.inspectionRequirements = newValues;
    },
    saveArrows(receivedDrawing) {
      this.inspectionRequirements = receivedDrawing.arrows;
      this.receivedArrows = receivedDrawing.arrows.length;
      this.deviceDrawing.base64 = receivedDrawing.dataURL;
      this.uploadImage();
    },
    toggleDev() {
      this.IPC = !this.IPC;
    },
  },
  watch: {
    deviceDrawing: function(newVal, oldVal) {
      if (this.isDrawingViewOpen == true) {
        this.isDrawingViewOpen = false;
      } else {
        this.startImageDrawing();
      }
      this.saved = false;
    },
    ref: function(val) {
      this.$emit("gotReference", val);
    },
    devType: function(val) {
      if (val == "Assembly") {
        this.finDefaults.push("complete", "burs", "visual", "functionality");
      } else {
        this.finDefaults.push("burs", "visual");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

.image-selector,
.image-selector > img {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 280px;

  &:hover {
    cursor: pointer;
  }
}

label.margin-top {
  margin-top: 16px;
}
span.no-requirements {
  color: #6a6a6a;
  font-style: italic;
}

select[multiple] {
  font-size: 12px;
  width: 100%;
  color: #707070;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #efefef;
  outline: none;
  transition: 0.5s;
  font-weight: 500;
  background-color: #ffffff;
  resize: none;

  &:focus {
    border: 1px solid #707070;
  }

  option {
    padding: 6px 4px;

    &:checked {
      color: white !important;
      background: #03758b linear-gradient(0deg, #03758b 0%, #03758b 100%);
    }
  }
}
</style>
